{
  "generatedFrom": "packages/layer-base/utils/{Brand,Theme}.ts",
  "sites": {
    "adb": [
      {
        "codes": [
          "ED"
        ],
        "title": "Eindhovens Dagblad",
        "main": "https://ed.nl",
        "subscription": "https://abonnement.ed.nl"
      },
      {
        "codes": [
          "PZ"
        ],
        "title": "PZC",
        "main": "https://pzc.nl",
        "subscription": "https://abonnement.pzc.nl"
      }
    ],
    "adr": [
      {
        "codes": [
          "AD"
        ],
        "title": "AD",
        "main": "https://ad.nl",
        "subscription": "https://abonnement.ad.nl"
      },
      {
        "codes": [
          "BD"
        ],
        "title": "Brabants Dagblad",
        "main": "https://bd.nl",
        "subscription": "https://abonnement.bd.nl"
      },
      {
        "codes": [
          "BS"
        ],
        "title": "BN DeStem",
        "main": "https://bndestem.nl",
        "subscription": "https://abonnement.bndestem.nl"
      },
      {
        "codes": [
          "DG"
        ],
        "title": "De Gelderlander",
        "main": "https://gelderlander.nl",
        "subscription": "https://abonnement.gelderlander.nl"
      },
      {
        "codes": [
          "ST"
        ],
        "title": "De Stentor",
        "main": "https://destentor.nl",
        "subscription": "https://abonnement.destentor.nl"
      },
      {
        "codes": [
          "TT"
        ],
        "title": "Tubantia",
        "main": "https://tubantia.nl",
        "subscription": "https://abonnement.tubantia.nl"
      }
    ],
    "aut": [
      {
        "codes": [
          "AUT",
          "ATR"
        ],
        "title": "AutoWeek",
        "main": "https://autoweek.nl",
        "subscription": "https://abonnement.autoweek.nl"
      }
    ],
    "da": [
      {
        "codes": [
          "DA"
        ],
        "title": "Dag Allemaal",
        "main": "https://dagallemaal.be",
        "subscription": "https://abonnement.dagallemaal.be"
      }
    ],
    "dat": [
      {
        "codes": [
          "DAT"
        ],
        "title": "Zo Zit Dat",
        "main": "https://zozitdat.nl",
        "subscription": "https://abonnement.zozitdat.nl"
      }
    ],
    "ddj": [
      {
        "codes": [
          "DDJ"
        ],
        "title": "Donald Duck Junior",
        "main": "https://donaldduck.nl",
        "subscription": "https://abonnement.donaldduck.nl"
      }
    ],
    "dm": [
      {
        "codes": [
          "DM"
        ],
        "title": "De Morgen",
        "main": "https://demorgen.be",
        "subscription": "https://abonnement.demorgen.be"
      }
    ],
    "don": [
      {
        "codes": [
          "DON",
          "DONEX",
          "DONPO"
        ],
        "title": "Donald Duck",
        "main": "https://donaldduck.nl",
        "subscription": "https://abonnement.donaldduck.nl"
      }
    ],
    "dpg": [],
    "flr": [
      {
        "codes": [
          "FLR"
        ],
        "title": "Flair",
        "main": "https://flair.nl",
        "subscription": "https://abonnement.flair.nl"
      }
    ],
    "flu": [
      {
        "codes": [
          "FLNL"
        ],
        "title": "Fluister",
        "main": "https://fluister.nl",
        "subscription": "https://abonnement.fluister.nl"
      },
      {
        "codes": [
          "FLBE"
        ],
        "title": "Fluister",
        "main": "https://fluister.be",
        "subscription": "https://abonnement.fluister.be"
      }
    ],
    "gg": [
      {
        "codes": [
          "GG"
        ],
        "title": "Goed Gevoel",
        "main": "https://goedgevoel.be",
        "subscription": "https://abonnement.goedgevoel.be"
      }
    ],
    "hl": [
      {
        "codes": [
          "HL"
        ],
        "title": "HLN",
        "main": "https://hln.be",
        "subscription": "https://abonnement.hln.be"
      }
    ],
    "hp": [
      {
        "codes": [
          "HP"
        ],
        "title": "Het Parool",
        "main": "https://parool.nl",
        "subscription": "https://abonnement.parool.nl"
      }
    ],
    "hu": [
      {
        "codes": [
          "HU"
        ],
        "title": "HUMO",
        "main": "https://humo.be",
        "subscription": "https://abonnement.humo.be"
      }
    ],
    "katri": [
      {
        "codes": [
          "KATRI"
        ],
        "title": "Katrien Duck",
        "main": "https://donaldduck.nl",
        "subscription": "https://abonnement.donaldduck.nl"
      }
    ],
    "kiosk": [
      {
        "codes": [
          "KIOSK"
        ],
        "title": "Kiosk",
        "main": "https://kiosk.nl",
        "subscription": "https://kiosk.nl"
      },
      {
        "codes": [
          "KIOSKBE"
        ],
        "title": "Kiosk",
        "main": "https://kiosk.be",
        "subscription": "https://kiosk.be"
      }
    ],
    "kwe": [
      {
        "codes": [
          "KWE"
        ],
        "title": "Kidsweek",
        "main": "https://kidsweek.nl",
        "subscription": "https://abonnement.kidsweek.nl"
      }
    ],
    "lezerij": [
      {
        "codes": [
          "PAK12"
        ],
        "title": "Lezerij",
        "main": "https://lezerij.nl",
        "subscription": "https://abonnement.lezerij.nl"
      },
      {
        "codes": [
          "TSBE"
        ],
        "title": "Lezerij",
        "main": "https://lezerij.be",
        "subscription": "https://abonnement.lezerij.be"
      }
    ],
    "lib": [
      {
        "codes": [
          "LIB",
          "LIBBO",
          "LIBPZ",
          "LIBSP"
        ],
        "title": "Libelle",
        "main": "https://libelle.nl",
        "subscription": "https://abonnement.libelle.nl"
      }
    ],
    "linda": [
      {
        "codes": [
          "LINDA"
        ],
        "title": "Linda",
        "main": "https://linda.nl",
        "subscription": "https://abonnement.linda.nl"
      }
    ],
    "mar": [
      {
        "codes": [
          "MAR",
          "MARPZ",
          "MARSP"
        ],
        "title": "Margriet",
        "main": "https://margriet.nl",
        "subscription": "https://abonnement.margriet.nl"
      }
    ],
    "primo": [
      {
        "codes": [
          "PRIMO"
        ],
        "title": "Primo",
        "main": "https://primo.be",
        "subscription": "https://abonnement.primo.be"
      }
    ],
    "sto": [
      {
        "codes": [
          "STO"
        ],
        "title": "Story",
        "main": "https://story.nl",
        "subscription": "https://abonnement.story.nl"
      }
    ],
    "storybe": [
      {
        "codes": [
          "STORYBE"
        ],
        "title": "Story",
        "main": "https://story.be",
        "subscription": "https://abonnement.story.be"
      }
    ],
    "tijdschrift": [],
    "topics": [
      {
        "codes": [
          "TOPICS"
        ],
        "title": "Topics",
        "main": "https://topics.nl",
        "subscription": null
      },
      {
        "codes": [
          "TOPICSBE"
        ],
        "title": "Topics",
        "main": "https://topics.be",
        "subscription": null
      }
    ],
    "tr": [
      {
        "codes": [
          "TR"
        ],
        "title": "Trouw",
        "main": "https://trouw.nl",
        "subscription": "https://abonnement.trouw.nl"
      }
    ],
    "tta": [
      {
        "codes": [
          "TTA"
        ],
        "title": "Totaal TV",
        "main": "https://totaaltv.nl",
        "subscription": "https://abonnement.totaaltv.nl"
      }
    ],
    "tvblad": [
      {
        "codes": [
          "TVBLAD"
        ],
        "title": "TeVe Blad",
        "main": "https://teveblad.be",
        "subscription": "https://abonnement.teveblad.be"
      }
    ],
    "tvfam": [
      {
        "codes": [
          "TVFAM"
        ],
        "title": "TV Familie",
        "main": "https://tvfamilie.be",
        "subscription": "https://abonnement.tvfamilie.be"
      }
    ],
    "vk": [
      {
        "codes": [
          "VK"
        ],
        "title": "De Volkskrant",
        "main": "https://volkskrant.nl",
        "subscription": "https://abonnement.volkskrant.nl"
      }
    ],
    "vro": [
      {
        "codes": [
          "VRO"
        ],
        "title": "Veronica Superguide",
        "main": "https://veronicasuperguide.nl",
        "subscription": "https://abonnement.veronicasuperguide.nl"
      }
    ],
    "vtw": [
      {
        "codes": [
          "BVWO"
        ],
        "title": "vtwonen",
        "main": "https://vtwonen.be",
        "subscription": "https://abonnement.vtwonen.be"
      },
      {
        "codes": [
          "VTW",
          "WLS"
        ],
        "title": "vtwonen",
        "main": "https://vtwonen.nl",
        "subscription": "https://abonnement.vtwonen.nl"
      }
    ]
  }
}
